import React from 'react';
import { Remove, Add } from '@material-ui/icons';
import IconRadiusButton from './IconRadiusButton';


export default function ExpandButton({ bgColor, color, ...props }) {
    return (
        <IconRadiusButton {...props}>
            {props.open ? <Remove style={{ color: color || 'white', width: 20, height: 30 }} /> : <Add style={{ color: color || 'white', width: 20, height: 30 }} />}
        </IconRadiusButton>
    );
}
